import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import {
  formatLoyaltyEsimInternationalDataHeading,
  getLoyaltyEsimGbAmount,
} from 'loyalty/utils/loyaltyBenefitLabels'
import {
  getLoyaltyBenefitModalPath,
  LOYALTY_ESIM_DETAILS_HASH,
} from 'loyalty/constants/loyaltyRoutes'

interface Props {
  layout: 'tile' | 'row'
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyEsimPackage(props: Props) {
  const { layout, benefit, benefitLabel } = props
  const intl = useIntl()

  const heading = formatLoyaltyEsimInternationalDataHeading(
    intl,
    getLoyaltyEsimGbAmount(benefit) ?? '-',
  )

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="esim_package"
    heading={heading}
    subtitle={benefitLabel}
    to={getLoyaltyBenefitModalPath(LOYALTY_ESIM_DETAILS_HASH)}
  />
}

export default LandingPageLoyaltyEsimPackage
